import { message } from "antd";
import { SOW_UPLOAD_API_URL } from "../config/constants";
import { requestNotificationsRefresh } from "./notificationsApi";
import { apiFetch } from "../utils/apiClient";



const getAuthHeader = () => {
  const rawToken =
    sessionStorage.getItem("token") ||
    sessionStorage.getItem("authToken") ||
    sessionStorage.getItem("accessToken");
  const tokenType = sessionStorage.getItem("tokenType") || "Bearer";

  if (!rawToken) {
    throw new Error("Authentication token not found. Please log in again.");
  }

  const normalizedToken = rawToken
    .replace(/^"|"$/g, "")
    .replace(/^Bearer\s+/i, "")
    .trim();

  return `${tokenType} ${normalizedToken}`;
};

export const uploadSOWDocument = async (
  file,
  projectId
) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("projectId", projectId);

  const response = await apiFetch(SOW_UPLOAD_API_URL, {
    method: "POST",
    headers: {
      Authorization: getAuthHeader(),
    },
    body: formData,
  }, "Failed to upload SOW document", { passthrough: [401, 400] });

  if (!response.ok) {
    if (response.status === 401) {
      throw new Error("Unauthorized. Please log in again.");
    }
    if (response.status === 400) {
      throw new Error("Invalid file or project ID");
    }
    throw new Error("Failed to upload SOW document");
  }

  const data = (await response.json());
  // SOW_ADDED / SOW_UPDATED
  requestNotificationsRefresh();
  return data;
};
